var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9613",
    "data-name": "Group 9613",
    transform: "translate(9368 -24414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "factory_black_24dp",
    transform: "translate(-9368 24413.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9612",
    "data-name": "Group 9612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8772",
    "data-name": "Group 8772"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38878",
    "data-name": "Rectangle 38878",
    width: 20,
    height: 20,
    transform: "translate(0 0.079)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "monitoring-svgrepo-com",
    transform: "translate(-9364.836 24390.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9332",
    "data-name": "Group 9332",
    transform: "translate(0 28.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9331",
    "data-name": "Group 9331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4833",
    "data-name": "Path 4833",
    d: "M15,28.339H.764A.779.779,0,0,0,0,29.132v9.282a.779.779,0,0,0,.764.793H6.09V41H4.017a.734.734,0,0,0,0,1.468h7.734a.734.734,0,0,0,0-1.468H9.679v-1.8H15a.779.779,0,0,0,.764-.793V29.132A.779.779,0,0,0,15,28.339Zm-.382,9.678H1.145V29.529H14.623Z",
    transform: "translate(0 -28.339)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4834",
    "data-name": "Path 4834",
    d: "M121.494,146.806a.6.6,0,0,0,.6-.6v-2.854a.6.6,0,0,0-1.2,0v2.854A.6.6,0,0,0,121.494,146.806Z",
    transform: "translate(-116.326 -138.38)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4835",
    "data-name": "Path 4835",
    d: "M169.431,100.965a.6.6,0,0,0,.6-.6V95.411a.6.6,0,0,0-1.2,0v4.954A.6.6,0,0,0,169.431,100.965Z",
    transform: "translate(-162.452 -92.354)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4836",
    "data-name": "Path 4836",
    d: "M217.375,128.471a.6.6,0,0,0,.6-.6v-3.694a.6.6,0,0,0-1.2,0v3.694A.6.6,0,0,0,217.375,128.471Z",
    transform: "translate(-208.585 -119.979)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4837",
    "data-name": "Path 4837",
    d: "M265.31,114.718a.6.6,0,0,0,.6-.6v-4.324a.6.6,0,1,0-1.2,0v4.324A.6.6,0,0,0,265.31,114.718Z",
    transform: "translate(-254.709 -106.17)",
    fill: "#a5a5a5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.3864233db82d9a68b59504f132526e3f.svg";
export { ForwardRef as ReactComponent };